var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 27.9998C4.6665 17.0005 4.6665 11.5008 8.0825 8.0825C11.5032 4.6665 17.0005 4.6665 27.9998 4.6665C38.9992 4.6665 44.4988 4.6665 47.9148 8.0825C51.3332 11.5032 51.3332 17.0005 51.3332 27.9998C51.3332 38.9992 51.3332 44.4988 47.9148 47.9148C44.5012 51.3332 38.9992 51.3332 27.9998 51.3332C17.0005 51.3332 11.5008 51.3332 8.0825 47.9148C4.6665 44.5012 4.6665 38.9992 4.6665 27.9998Z",
    stroke: "#354764",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 25.6665C11.6665 19.0678 11.6665 15.7662 13.7175 13.7175C15.7662 11.6665 19.0678 11.6665 25.6665 11.6665H30.3332C36.9318 11.6665 40.2335 11.6665 42.2822 13.7175C44.3332 15.7662 44.3332 19.0678 44.3332 25.6665V30.3332C44.3332 36.9318 44.3332 40.2335 42.2822 42.2822C40.2335 44.3332 36.9318 44.3332 30.3332 44.3332H25.6665C19.0678 44.3332 15.7662 44.3332 13.7175 42.2822C11.6665 40.2335 11.6665 36.9318 11.6665 30.3332V25.6665Z",
    stroke: "#354764",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 27.9998C18.6665 25.5245 19.6498 23.1505 21.4002 21.4002C23.1505 19.6498 25.5245 18.6665 27.9998 18.6665C30.4752 18.6665 32.8492 19.6498 34.5995 21.4002C36.3498 23.1505 37.3332 25.5245 37.3332 27.9998C37.3332 30.4752 36.3498 32.8492 34.5995 34.5995C32.8492 36.3498 30.4752 37.3332 27.9998 37.3332C25.5245 37.3332 23.1505 36.3498 21.4002 34.5995C19.6498 32.8492 18.6665 30.4752 18.6665 27.9998Z",
    stroke: "#354764",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 28C31.5 28.9283 31.1313 29.8185 30.4749 30.4749C29.8185 31.1313 28.9283 31.5 28 31.5C27.0717 31.5 26.1815 31.1313 25.5251 30.4749C24.8687 29.8185 24.5 28.9283 24.5 28C24.5 27.0717 24.8687 26.1815 25.5251 25.5251C26.1815 24.8687 27.0717 24.5 28 24.5C28.9283 24.5 29.8185 24.8687 30.4749 25.5251C31.1313 26.1815 31.5 27.0717 31.5 28Z",
    fill: "#354764"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 27.9998V18.6665M27.9997 27.9998L36.1663 31.4998M27.9997 27.9998L19.833 31.4998",
    stroke: "#354764",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.333V23.333M10.5 32.6663V39.6663",
    stroke: "#354764",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAq);
export default __webpack_public_path__ + "static/media/icon-aq.81bb4ef0ffeba164b0baa696d0abfeb5.svg";
export { ForwardRef as ReactComponent };